export default __webpack_public_path__ + "static/media/project7.bf77a196.jpg";